import { render, staticRenderFns } from "./ProductSeriesList.vue?vue&type=template&id=95d49cca&scoped=true&"
import script from "./ProductSeriesList.vue?vue&type=script&lang=js&"
export * from "./ProductSeriesList.vue?vue&type=script&lang=js&"
import style0 from "./ProductSeriesList.vue?vue&type=style&index=0&id=95d49cca&prod&lang=scss&scoped=true&"
import style1 from "./ProductSeriesList.vue?vue&type=style&index=1&id=95d49cca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d49cca",
  null
  
)

export default component.exports